import { render } from "./CollectNetworkForm.vue?vue&type=template&id=0ad9e1c2"
import script from "./CollectNetworkForm.vue?vue&type=script&lang=js"
export * from "./CollectNetworkForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__